var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-row',_vm._l((_vm.images),function(item,index){return _c('v-col',{key:index,attrs:{"cols":"3"}},[_c('v-img',{attrs:{"src":item,"contain":"","height":"100"}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }